import { gql } from "@apollo/client";

export const NEXT_BOX_DELAY_FRAGMENT = gql`
  fragment NextBoxDelay on SubscriptionObject {
    id
    billingDay
    nextBoxBillingDate
    nextBoxRecommendationsDate
    nextBoxSummaryTitle
    nextBoxSummarySubTitle
    canDelayNextBox
    nextBoxDelayAvailableDays
    nextBoxDelayMaxDays
    nextBoxDelay {
      id
      originalBillingDate
      delayedBillingDate
      originalBillingDay
      daysDelayed
      daysRemaining
      isBillingDayUpdated
    }
  }
`;

export const GET_MEMBER_NEXT_BOX_DELAY = gql`
  ${NEXT_BOX_DELAY_FRAGMENT}
  query MemberNextBoxDelay {
    me {
      id
      subscription {
        ...NextBoxDelay
        orderOpenForChanges {
          id
        }
        activeAddOns: subscribedAddons(status: ACTIVE) {
          id
        }
      }
    }
  }
`;

export const DELAY_NEXT_BOX = gql`
  ${NEXT_BOX_DELAY_FRAGMENT}
  mutation DelayNextBox($input: DelayNextBoxInput!) {
    delayNextBox(input: $input) {
      subscription {
        ...NextBoxDelay
      }
      errors {
        field
        messages
      }
    }
  }
`;
